import { ChevronDownIcon } from '@chakra-ui/icons'
import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'

export const ActionsMenu = ({ actions }) => {
  return actions ? (
    <Menu>
      <MenuButton variant={'solid'} as={Button} rightIcon={<ChevronDownIcon />}>
        Actions
      </MenuButton>
      <MenuList>
        {actions.map(({ action, text }, index) => (
          <MenuItem
            _focus={{ bgColor: 'primary.100' }}
            key={index}
            onClick={() => action()}
          >
            {text}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  ) : null
}
